import { isMobileOnly } from 'react-device-detect';
import { esHorizontal } from './orientationUtils';

export function styleNotAllowed(notAllowed){
    return { cursor: notAllowed ? "not-allowed" : "auto" };
}

export function setCssVariable(nombreVariableAjustar, nombreVariableNuevoValor){
    document.documentElement.style.setProperty(
        "--" + nombreVariableAjustar,
        getComputedStyle(document.documentElement).getPropertyValue("--" + nombreVariableNuevoValor)
    );
}

export function getCssVariable(nombreVariable){
    return getComputedStyle(document.documentElement).getPropertyValue("--" + nombreVariable);
}

export function setEstilosSoloMovil(){
    if (isMobileOnly){
        setCssVariable("tamLetraListaLayers", "tamLetraListaLayersMob");
        setCssVariable("tamLetraListaResumen", "tamLetraListaResumenMob");
        if (esHorizontal()){
            setEstilosMovilHoriz();
        } else {
            setEstilosMovilVert();
        }
    }
}

function setEstilosGeneral(sufijo = ""){
    setCssVariable("altoMaxLegend", "altoMaxLegendMob" + sufijo);
    setCssVariable("altoMaxLayerList", "altoMaxLayerListMob" + sufijo);
    setCssVariable("altoMaxBasemapGallery", "altoMaxBasemapGalleryMob" + sufijo);
    setCssVariable("altoMaxCustomWidget", "altoMaxCustomWidgetMob" + sufijo);
    setCssVariable("anchoMaxCustomWidget", "anchoMaxCustomWidgetMob" + sufijo);
    setCssVariable("anchoInfoAdicional", "anchoInfoAdicionalMob" + sufijo);
    setCssVariable("widthPopup", "widthPopupMob" + sufijo);
}

export function setEstilosMovilHoriz(){
    setEstilosGeneral("H");
}

export function setEstilosMovilVert(){
    setEstilosGeneral();
}